<div>
  <ng-container *ngIf="!isEditing">
    <p *ngIf="stepName">
      <b>{{ stepName }}</b>
    </p>
    <p *ngIf="data" [innerHtml]="sanitizeHtml(data)"></p>
    <span *ngIf="!data">{{ placeholder }}</span>
    <i class="fa fa-edit" (click)="toggleEdit()"></i>
  </ng-container>
  <ng-container *ngIf="isEditing">
    <input
      [(ngModel)]="stepName"
      name="name"
      id="name_id"
      type="text"
      style="background-color: #dbdbdb !important"
      class="form-control m-1"
      placeholder="Enter step name..."
      required
    />

    <div *ngIf="workflowData?.primaryLanguage.workflowStepType == 'text'">
      <angular-editor
        class="m-2"
        id="editor"
        [editor]="editor"
        [(ngModel)]="data"
        [toolbar]="toolbar"
        placeholder="Enter text here..."
      ></angular-editor>
    </div>
    <button (click)="saveEdit()" class="btn btn-primary m-1">
      {{ "Form.SAVE" | translate }}
    </button>
  </ng-container>
</div>
